import { Holder3D } from "../../../types/holder3d";
import { IPartsChildren } from "../../../types/IPartsConfigSchema";

/** Modifies the Holder3D by removing and renaming parts */

export function removeAndRenameParts(
  conf: IPartsChildren,
  holder3D: Holder3D,
  cells: number,
) {
  if (!conf.removeAndRename) {
    return;
  }

  conf.removeAndRename.forEach((configInfo) => {
    const obj = holder3D.getObjectByName(configInfo.name);
    if (!obj) return;

    if (cells >= configInfo.min && cells <= configInfo.max) {
      // -------- Keep
      if (configInfo.parent) {
        // ---------------------------------------- Attach to new parent
        const newParent = holder3D.getObjectByName(configInfo.parent);
        if (newParent) newParent.attach(obj);
      }

      if (configInfo.rename) {
        // ---------------------------------------- Rename
        obj.name = configInfo.rename;
      }
    } else {
      // ---------------------------------------------------------- Discard
      obj.removeFromParent();
    }
  });
}
